import type { SessionKind } from "../hooks/audit/useControlSessionEnvelope";

/**
 * Base path for the template-scoped work paper value endpoints, for whichever
 * entity the session hangs off.
 *
 * Both routers expose the same six routes under this prefix — `/state`,
 * `/generate`, `/generate/async`, `/generate/status`,
 * `/generated-values/{fieldId}` and
 * `/generated-attribute-descriptions/{attributeId}` — with identical bodies and
 * responses. Only the prefix differs, because each resolves its session id
 * against a different table.
 *
 * This exists as a helper rather than an inline ternary per call site because
 * there are seven of them across three files. Twice already in this effort a
 * control-only path was branched at some call sites and missed at others, and
 * the miss was invisible: the control route answers 200 for a control session
 * and 404s for a work-step one, so nothing fails until someone opens the page
 * on a work step.
 */
export const workPaperTemplateApiBase = (
  sessionKind: SessionKind,
  sessionId: string,
  templateId: string,
): string =>
  sessionKind === "work_step"
    ? `/work-steps/work-step-sessions/${sessionId}/templates/${templateId}`
    : `/sessions/${sessionId}/templates/${templateId}`;
